import type { UseQueryOptions } from "@tanstack/react-query";
import { skipToken, useQuery, useQueryClient } from "@tanstack/react-query";
import api from "../api";
import urls from "../urls";
import type { ConsumptionShares } from "../utils/backend-types";

export function useConsumptionShare(
  consumptionShareId?: number | null,
  options?: Partial<UseQueryOptions<ConsumptionShares>>
) {
  const { data, isLoading, error } = useQuery({
    queryKey: ["consumptionShareData", { consumptionShareId }],
    queryFn: consumptionShareId
      ? () => fetchConsumptionShare(consumptionShareId)
      : skipToken,
    ...options
  });

  const queryClient = useQueryClient();

  function invalidateConsumptionShareData() {
    return queryClient.invalidateQueries({
      queryKey: ["consumptionShareData", { consumptionShareId }]
    });
  }

  function saveConsumptionShareData(
    consumptionShareModelData: ConsumptionShares
  ) {
    return api.post(urls.api.consumptionShare(), consumptionShareModelData);
  }

  return {
    data,
    isLoading,
    error,
    invalidateConsumptionShareData,
    saveConsumptionShareData
  };
}

async function fetchConsumptionShare(consumptionShareId: number) {
  const consumptionShareUrl = urls.api.consumptionShare(consumptionShareId);
  const response = await api.get<ConsumptionShares>(consumptionShareUrl);
  return response.data;
}
